import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ClaimUsageEmailParamVm } from 'src/app/feature-module/product/model/claim-usage-email-param-vm';
import { EBDashboardDiseaseVm } from 'src/app/feature-module/product/model/eb-dashboard-disease-vm';
import { EbDashboardEmailService } from 'src/app/feature-module/product/service/eb-dashboard-email/eb-dashboard-email.service';
import { productCodes } from 'src/app/utility/enum/global-enum';
import { MessageService } from 'src/app/utility/services/message/message.service';

@Component({
  selector: 'app-dialog-claim-usage-email-disease-details',
  templateUrl: './dialog-claim-usage-email-disease-details.component.html',
  styleUrls: ['./dialog-claim-usage-email-disease-details.component.scss']
})
export class DialogClaimUsageEmailDiseaseDetailsComponent implements OnInit {
  diseaseForm: any;
  ipDiseases: EBDashboardDiseaseVm[];
  opDiseases: EBDashboardDiseaseVm[];

  constructor(public dialogRef: MatDialogRef<DialogClaimUsageEmailDiseaseDetailsComponent>,
    private fb: FormBuilder,
    private ebDashboardEmailService: EbDashboardEmailService,
    private messageService: MessageService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.ipDiseases = this.data.diseaseVms.filter(x => x.productCode == productCodes.IP)
    this.opDiseases = this.data.diseaseVms.filter(x => x.productCode == productCodes.OutPatient_Per_Disability)
    this.diseaseForm = this.fb.group({
      ipDiseaseId: this.ipDiseases.length ? [null, Validators.required] : [null],
      opDiseaseId: this.opDiseases.length ? [null, Validators.required] : [null]
    });
  }

  submit() {
    const payload: ClaimUsageEmailParamVm = {
      enrolId: this.data.enrolId,
      oPDiseaseId: this.diseaseForm.value.opDiseaseId,
      iPDiseaseId: this.diseaseForm.value.ipDiseaseId
    };
    this.ebDashboardEmailService.sendClaimUsageEmail(payload).subscribe(
      (res: any) => {
        this.messageService.show(this.messageService.msgEmailSendSuccess, "success");
        this.dialogRef.close();
      },
      error => {
        this.messageService.show(error.error.message, "error");
      })
  }

}
